// For Drag & Drop - Refer https://github.com/larkintuckerllc/hello-react-dnd
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  DropTarget,
  DragSource
} from 'react-dnd'
import { Image, Label, Dropdown } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Capitalize from 'Lib/Capitalize'
import ConfirmPopup from 'Components/ConfirmPopup'
import ConfirmModal from 'Components/ConfirmModal'
import VideoActions from 'Redux/VideoRedux'
import thumb from 'Images/thumb-placeholder.png'
import styles from './VideoItemStyles'
import UploadToJw from 'Components/UploadToDrive/UploadToJw'
import VideoStatusDropDown from 'Components/VideoPlayer/ToolBar/VideoStatusDropDown'

class VideoItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  onUnVersion = (videoId) => () => {
    // e.stopPropagation()
    this.props.videosUnversionRequest(videoId)
  }

  onVideoDelete = () => {
    this.props.videosDeleteRequest(this.props.video.id)
  }

  componentDidUpdate (prevProps) {
    if (this.props.dragVideo !== prevProps.dragVideo) {
      if(this.props.dragVideo && this.props.dragVideo.video) {
        this.props.videosSetDragVideoId(this.props.dragVideo.video.id)
      }
      else {
        this.props.videosSetDragVideoId(null)
      }
    }
  }

  render () {
    const {
      connectDragSource, connectDropTarget, isDragging, isOver, video
    } = this.props

    let maskStyle = {}
    if (isOver) {
      maskStyle = { backgroundColor: 'rgba(0,0,0,0.4)' }
    }
    const imgLabel = video.videosCount > 0
      ? {color: 'yellow', corner: 'right'} : null

    return connectDragSource(connectDropTarget(
      <div
        className={styles.videoItemWrap}
        style={{ opacity: isDragging ? 0 : 1 }}
        key={video.id}>
        <VideoStatusDropDown video={video} className={styles.statusDropDown} />
        <Link
          to={'/videos/' + video.id} className={styles.linkImages}>
          <Image
            className={styles.videoImg}
            src={video.posterUrl || thumb}
            alt={video.title}
            label={imgLabel}
          />
        </Link>
        <div className={styles.infoWrap}>
          <Link to={'/videos/' + video.id} className={styles.link}>
            <div className={styles.title}>{Capitalize(video.title)}</div>
            <div className={styles.meta}>
              <span className={styles.user}>{video.username}</span>
              <span className={styles.dot}>&#183;</span>
              <span className={styles.date}>{video.createdAt}</span>
            </div>
          </Link>
          { this.props.userData.role !== 'collaborator' &&
            <Dropdown
              icon='ellipsis vertical'
              direction='left'
              className={styles.dropdown}>
              <Dropdown.Menu style={{zIndex: '4'}}>
                <UploadToJw menuItemText="Upload to JW"
                            title="Publish video JW Platform"
                            video={video}/>
                <ConfirmModal
                  title="Delete Video"
                  explainText="Are you sure you want to delete this video?"
                  trigger={
                    <Dropdown.Item>Delete</Dropdown.Item>
                  }
                  onConfirm={this.onVideoDelete}
                />
              </Dropdown.Menu>
            </Dropdown>
          }
        </div>
        {isOver && <div className={styles.mask} style={maskStyle} /> }
        { this.props.userData.role !== 'collaborator' &&
          video.videosCount > 0 &&
          <ConfirmPopup
            explainText='UnVersion Videos?'
            trigger={
              <Label
                color='yellow'
                style={{ zIndex: 99 }}
                attached='top right'>{video.videosCount + 1}</Label>
            }
            position='bottom right'
            onConfirm={this.onUnVersion(video.id)}
          />
        }
      </div>
    ))
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData
})

const mapDispatchToProps = (dispatch) => ({
  videosUnversionRequest: videoId =>
    dispatch(VideoActions.videosUnversionRequest(videoId)),
  videosDeleteRequest: videoId =>
    dispatch(VideoActions.videosDeleteRequest(videoId)),
  videosSetDragVideoId: videoId =>
    dispatch(VideoActions.videosSetDragVideoId(videoId))
})

const ReduxVideoItem = connect(mapStateToProps, mapDispatchToProps)(VideoItem)

const cardSource = {
  beginDrag (props) {
    return { video: props.video }
  }
}

const cardTarget = {
  drop (props, monitor) {
    const { video } = monitor.getItem() // dropped video
    if (video.id !== props.video.id) {
      props.onDrop(props.video, video)
    }
  }
}

const DraggableItem = DragSource('CARD', cardSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
  dragVideo: monitor.getItem()
}))(ReduxVideoItem)

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))(DraggableItem)



// WEBPACK FOOTER //
// ./src/Pages/Videos/VideoItem.js